import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { GETEventService } from '../../../../services/fetchServices/fetchEvent/GET/get-event.service';
import { ThemeService } from '../../../../services/shared/theme.service';
import { WebSocketService } from '../../../../services/web-socket.service';
import { SvgIconService } from '../../../../services/shared/icons/svg-icon.service';

@Component({
  selector: 'app-week-template',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './week-template.component.html',
  styleUrls: ['./week-template.component.scss'],
})
export class WeekTemplateComponent {
  constructor(
    private getEventService: GETEventService,
    public themeService: ThemeService,
    public socketService: WebSocketService,
    public svgIconService: SvgIconService,
    private cdr: ChangeDetectorRef,
  ) {}

  @Input() minutesHidden = false;
  @Input() date!: any;
  myStats: any = {};
  availableHoursWeekly: any = {};

  ngOnInit() {
    this.socketOnStatsUpdate();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['date'] && this.date) {
      this.fetchEventStatsWithTime(this.date);
    }
  }

  get weekNr(): number {
    const date = new Date(this.date);

    // ISO-Kalenderwoche berechnen
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));

    const week1 = new Date(date.getFullYear(), 0, 4);
    week1.setHours(0, 0, 0, 0);

    return (
      1 +
      Math.round(
        ((date.getTime() - week1.getTime()) / 86400000 -
          3 +
          ((week1.getDay() + 6) % 7)) /
          7,
      )
    );
  }

  async socketOnStatsUpdate() {
    this.socketService.onStatsUpdate().subscribe(async (event) => {
      const newStats = event.event.statistics[0];
      if (newStats) {
        const s = newStats;
        this.myStats = {
          ...this.myStats,
          ...{
            MEETINGEVENT_minutes: Number(s.MEETINGEVENT_minutes),
            MISSIONEVENT_minutes: Number(s.MISSIONEVENT_minutes),
            HOLIDAYEVENT_minutes: Number(s.HOLIDAYEVENT_minutes),
            SICKEVENT_minutes: Number(s.SICKEVENT_minutes),
            ILLNESSREPRESENTATIONEVENT_minutes: Number(
              s.ILLNESSREPRESENTATIONEVENT_minutes,
            ),
            NOTBILLABLEEVENT_minutes: Number(s.NOTBILLABLEEVENT_minutes),
            PRIVATEEVENT_minutes: Number(s.PRIVATEEVENT_minutes),
            TEAMEVENT_minutes: Number(s.TEAMEVENT_minutes),
            TOTAL: Number(s.TOTAL),
          },
        };
        // console.log("Event-Statistiken:", this.myStats);
      }

      //const newAvailableHours = event.event.weekylHoursAvailable[0];
      //if (newAvailableHours) {
      //  const a = newAvailableHours;
      //  this.availableHoursWeekly = { ...this.availableHoursWeekly, ...{
      //  AVAILABLE_WEEKLY_HOURS: Number(a.AVAILABLE_WEEKLY_HOURS),
      //  }};
      //   console.log("SOCKET_UPDATE-AVAILABLE_HOURS_WEEKLY:", this.availableHoursWeekly);
      //}
    });
  }

  toRoundedHours(minutes: number): number {
    return Math.round((minutes / 60) * 100) / 100;
  }

  async fetchEventStatsWithTime(endTime: any) {
    const date = new Date(endTime);

    const endDateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

    this.getEventService.fetchEventStatsWithTime(endDateStr).subscribe({
      next: (stats: any) => {
        if (stats?.statistics?.length > 0) {
          const s = stats.statistics[0];
          this.myStats = {
            MEETINGEVENT_minutes: Number(s.MEETINGEVENT_minutes),
            MISSIONEVENT_minutes: Number(s.MISSIONEVENT_minutes),
            HOLIDAYEVENT_minutes: Number(s.HOLIDAYEVENT_minutes),
            SICKEVENT_minutes: Number(s.SICKEVENT_minutes),
            ILLNESSREPRESENTATIONEVENT_minutes: Number(
              s.ILLNESSREPRESENTATIONEVENT_minutes,
            ),
            NOTBILLABLEEVENT_minutes: Number(s.NOTBILLABLEEVENT_minutes),
            PRIVATEEVENT_minutes: Number(s.PRIVATEEVENT_minutes),
            TEAMEVENT_minutes: Number(s.TEAMEVENT_minutes),
            TOTAL: Number(s.TOTAL),
          };
        }

        if (stats?.weekylHoursAvailable?.length > 0) {
          const a = stats.weekylHoursAvailable[0];

          this.availableHoursWeekly = {
            AVAILABLE_WEEKLY_HOURS: Number(a.AVAILABLE_WEEKLY_HOURS),
          };
        }

        // Angular-Ansicht sofort aktualisieren
        this.cdr.detectChanges();
      },
      error: (error) => console.error('API-Fehler:', error),
    });
  }
}
